import { AuthoGuard } from './guards/autho.guard';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomePageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'customers',
    loadChildren: () => import('./customers/customers.module').then(m => m.CustomersPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'new-customer',
    loadChildren: () => import('./new-customer/new-customer.module').then(m => m.NewCustomerPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then(m => m.UserPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'customers',
    loadChildren: () => import('./customers/customers.module').then(m => m.CustomersPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'new-customer',
    loadChildren: () => import('./new-customer/new-customer.module').then(m => m.NewCustomerPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'see-customer',
    loadChildren: () => import('./see-customer/see-customer.module').then(m => m.SeeCustomerPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'companies',
    loadChildren: () => import('./companies/companies.module').then(m => m.CompaniesPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'new-companie',
    loadChildren: () => import('./new-companie/new-companie.module').then(m => m.NewCompaniePageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'association-contact-list',
    loadChildren: () => import('./association-contact-list/association-contact-list.module').then(m => m.AssociationContactListPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'new-section',
    loadChildren: () => import('./new-section/new-section.module').then(m => m.NewSectionPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'project',
    loadChildren: () => import('./project/project.module').then(m => m.ProjectPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'new-project',
    loadChildren: () => import('./new-project/new-project.module').then(m => m.NewProjectPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'new-proposal',
    loadChildren: () => import('./new-proposal/new-proposal.module').then(m => m.NewProposalPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'employees',
    loadChildren: () => import('./employees/employees.module').then(m => m.EmployeesPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'new-employee',
    loadChildren: () => import('./new-employee/new-employee.module').then(m => m.NewEmployeePageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'assing-tasks',
    loadChildren: () => import('./assing-tasks/assing-tasks.module').then(m => m.AssingTasksPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'assing-materials',
    loadChildren: () => import('./assing-materials/assing-materials.module').then(m => m.AssingMaterialsPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'documents',
    loadChildren: () => import('./documents/documents.module').then(m => m.DocumentsPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'new-document',
    loadChildren: () => import('./new-document/new-document.module').then(m => m.NewDocumentPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'documents-category',
    loadChildren: () => import('./documents-category/documents-category.module').then(m => m.DocumentsCategoryPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'new-document-category',
    loadChildren: () => import('./new-document-category/new-document-category.module').then(m => m.NewDocumentCategoryPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'materials',
    loadChildren: () => import('./materials/materials.module').then(m => m.MaterialsPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'new-material',
    loadChildren: () => import('./new-material/new-material.module').then(m => m.NewMaterialPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'type-material',
    loadChildren: () => import('./type-material/type-material.module').then(m => m.TypeMaterialPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'new-type-material',
    loadChildren: () => import('./new-type-material/new-type-material.module').then(m => m.NewTypeMaterialPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'confirm-sub-viability',
    loadChildren: () => import('./confirm-sub-viability/confirm-sub-viability.module').then(m => m.ConfirmSubViabilityPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'client-claime',
    loadChildren: () => import('./client-claime/client-claime.module').then(m => m.ClientClaimePageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'client-claime-list',
    loadChildren: () => import('./client-claime-list/client-claime-list.module').then(m => m.ClientClaimeListPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'customer-select-materials',
    // eslint-disable-next-line max-len
    loadChildren: () => import('./customer-select-materials/customer-select-materials.module').then(m => m.CustomerSelectMaterialsPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'customers-select-materials-list',
    // eslint-disable-next-line max-len
    loadChildren: () => import('./customers-select-materials-list/customers-select-materials-list.module').then(m => m.CustomersSelectMaterialsListPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'card-payment',
    loadChildren: () => import('./card-payment/card-payment.module').then(m => m.CardPaymentPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'access-services',
    loadChildren: () => import('./access-services/access-services.module').then(m => m.AccessServicesPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'rol',
    loadChildren: () => import('./rol/rol.module').then(m => m.RolPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'employee-department',
    loadChildren: () => import('./employee-department/employee-department.module').then(m => m.EmployeeDepartmentPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'new-employee-department',
    loadChildren: () => import('./new-employee-department/new-employee-department.module').then(m => m.NewEmployeeDepartmentPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'see-project',
    loadChildren: () => import('./see-project/see-project.module').then(m => m.SeeProjectPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'calendar',
    loadChildren: () => import('./calendar/calendar.module').then(m => m.CalendarPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'user-rol',
    loadChildren: () => import('./user-rol/user-rol.module').then(m => m.UserRolPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'see-employee',
    loadChildren: () => import('./see-employee/see-employee.module').then(m => m.SeeEmployeePageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'see-association-contact',
    loadChildren: () => import('./see-association-contact/see-association-contact.module').then(m => m.SeeAssociationContactPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'see-claime',
    loadChildren: () => import('./see-claime/see-claime.module').then(m => m.SeeClaimePageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'see-customer-send-materials',
    // eslint-disable-next-line max-len
    loadChildren: () => import('./see-customer-send-materials/see-customer-send-materials.module').then(m => m.SeeCustomerSendMaterialsPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'my-tasks',
    loadChildren: () => import('./my-tasks/my-tasks.module').then(m => m.MyTasksPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'new-template',
    loadChildren: () => import('./new-template/new-template.module').then(m => m.NewTemplatePageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'template-list',
    loadChildren: () => import('./template-list/template-list.module').then(m => m.TemplateListPageModule),
    canActivate: [AuthoGuard]
  },
  {
    path: 'task-project',
    loadChildren: () => import('./task-project/task-project.module').then(m => m.TaskProjectPageModule)
  },
  {
    path: 'inspeccions',
    loadChildren: () => import('./inspeccions/inspeccions.module').then(m => m.InspeccionsPageModule)
  },
  {
    path: 'new-inspection',
    loadChildren: () => import('./new-inspection/new-inspection.module').then(m => m.NewInspectionPageModule)
  },
  {
    path: 'project-photos',
    loadChildren: () => import('./project-photos/project-photos.module').then(m => m.ProjectPhotosPageModule)
  },
  {
    path: 'template-form',
    loadChildren: () => import('./template-form/template-form.module').then(m => m.TemplateFormPageModule)
  },
  {
    path: 'template-form-list',
    loadChildren: () => import('./template-form-list/template-form-list.module').then(m => m.TemplateFormListPageModule)
  },
  {
    path: 'proposal-list',
    loadChildren: () => import('./proposal-list/proposal-list.module').then(m => m.ProposalListPageModule)
  },
  {
    path: 'see-proposal-docs',
    loadChildren: () => import('./see-proposal-docs/see-proposal-docs.module').then(m => m.SeeProposalDocsPageModule)
  },
  {
    path: 'document-list',
    loadChildren: () => import('./document-list/document-list.module').then(m => m.DocumentListPageModule)
  },
  {
    path: 'messages',
    loadChildren: () => import('./messages/messages.module').then(m => m.MessagesPageModule)
  },
  {
    path: 'email-modal',
    loadChildren: () => import('./email-modal/email-modal.module').then(m => m.EmailModalPageModule)
  },
  {
    path: 'pdf-preview',
    loadChildren: () => import('./pdf-preview/pdf-preview.module').then(m => m.PdfPreviewPageModule)
  },
  {
    path: 'see-files',
    loadChildren: () => import('./see-files/see-files.module').then(m => m.SeeFilesPageModule)
  },
  {
    path: 'send-sub-email',
    loadChildren: () => import('./send-sub-email/send-sub-email.module').then(m => m.SendSubEmailPageModule)
  },
  {
    path: 'accidents-list',
    loadChildren: () => import('./accidents-list/accidents-list.module').then(m => m.AccidentsListPageModule)
  },
  {
    path: 'accident-form',
    loadChildren: () => import('./accident-form/accident-form.module').then(m => m.AccidentFormPageModule)
  },
  {
    path: 'approval-received',
    loadChildren: () => import('./approval-received/approval-received.module').then(m => m.ApprovalReceivedPageModule)
  },
  {
    path: 'final-payment',
    loadChildren: () => import('./final-payment/final-payment.module').then(m => m.FinalPaymentPageModule)
  },
  {
    path: 'home-page',
    loadChildren: () => import('./home-page/home-page.module').then(m => m.HomePagePageModule),
    canActivate: [AuthoGuard]

  },
  {
    path: 'payment-list',
    loadChildren: () => import('./payment-list/payment-list.module').then(m => m.PaymentListPageModule),
    canActivate: [AuthoGuard]

  },
  {
    path: 'send-payment',
    loadChildren: () => import('./send-payment/send-payment.module').then(m => m.SendPaymentPageModule),
  },
  {
    path: 'proposal-list-new-proposal',
    // eslint-disable-next-line max-len
    loadChildren: () => import('./proposal-list-new-proposal/proposal-list-new-proposal.module').then(m => m.ProposalListNewProposalPageModule)
  },
  {
    path: 'change-status-form',
    loadChildren: () => import('./change-status-form/change-status-form.module').then(m => m.ChangeStatusFormPageModule)
  },
  {
    path: 'assign-materials',
    loadChildren: () => import('./assign-materials/assign-materials.module').then(m => m.AssignMaterialsPageModule)
  },
  {
    path: 'info',
    loadChildren: () => import('./info/info.module').then(m => m.InfoPageModule)
  },
  {
    path: 'assign-materials-modal',
    loadChildren: () => import('./assign-materials-modal/assign-materials-modal.module').then(m => m.AssignMaterialsModalPageModule)
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsPageModule)
  },




];

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
